module.exports = __webpack_public_path__ + "static/media/editProfile.369caf5d.svg";